<template>
	<div>
		<div class="head">
			<img src="@/assets/headImg/headimg.jpg" style="width: 100%; 
		vertical-align:top;" class="lunbo1" />
			<img src="../../assets/lunbo.jpg" style="width: 100%;" class="lunbo2">
		</div>
		<div class="success_box">
			<p class="text"> 
			 <span>诚挚欢迎您参与中华医学会第一次全国细菌真菌感染学术会议，您已完成线上参会报名，感谢您对本次会议的关注！</span>
			 </p>
			<div style="width: 90%;margin: 0 auto;">
				<div class="btn" @click="homePage">返回首页</div>
				<!-- <div class="btn" @click="signln">去登录</div> -->
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selete:'',
				on_line:'感谢您关注本次会议，请使用手机号+密码或短信验证方式登录会议网站，查看更多信息请访问大会官网http://bisc2021.ganzhiyu.com！',
				on_lineHead:'注册成功，'
			}
		},
		methods:{
			homePage(){
				this.$router.push({
					path:'/'
				})
			},
			signln(){
				this.$router.push({
					path:'/signIn'
				})
			},
			isselete(){
				if(this.selete == 2){
					this.on_line = '感谢您关注本次会议，请您于4月8日会议报到当天前往会议现场进行线下交费，更多信息请访问大会官网http://bisc2021.ganzhiyu.com，首页右侧联系我们模块进行注册咨询',
					this.on_lineHead = '线下参会注册成功，'
				}
			}
		},
		mounted() {
			this.selete = this.$route.query.selete,
			this.isselete();
			
		}
	}
</script>

<style scoped  lang="scss">
	@import  '@/assets/style/style.scss';
	.success_box {
		width: 430px;
		height: 200px;
		// border: 1px solid #cfcfcf;
		margin: 0 auto;
		margin-top: 150px;
	}
	.head {
		width: 980px;
		margin: 0 auto;
		padding-right: 16px;
	}
	.text{
		font-size: 17px;
		// margin-left: 50%;
		// transform: translateX(-50%);
		margin-top: 20px;
		margin-bottom: 30px;
		color: #666
	}

	.btn {
		background-image: linear-gradient(to right, #5173ff, #3dbbff);
		width: 150px;
		height: 35px;
		line-height: 35px;
		border-radius: 5px;
		color: #fff;
		text-align: center;
		font-size: 15px;
		cursor: pointer;
		margin: 0 auto;
		
	}
	.lunbo2 {
		display: none;
	}
	
	.isshow {
		visibility: hidden;
	}
	@media (max-width:500px) {
		.success_box{
			margin-top: 100px;
			width: 85%;
		}
		.lunbo1 {
			display: none;
		}
			
		.lunbo2 {
			display: block;
		}
			
		.isshow {
			visibility: visible;
		}
		.btn{
			width: 130px;
		}
			
		.head {
			padding-right: 0;
			width: 100%;
		}
	}

</style>
